import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LabelStandart from '../LabelStandart/LabelStandart';
import InfoWrapper from '../InfoWrapper/InfoWrapper';

import { StyledInfoPanel } from './styles/StyledInfoPanel';


class InfoPanel extends Component {
  render() {
    const { locationData, serviceData, timeData, } = this.props;
    return (
      <StyledInfoPanel>
        <div className="row">
          
            { (locationData.show && locationData.status) &&
              <div className="col col-lg-4 col-md-12">
                <LabelStandart
                  title={locationData.title}
                />
                <InfoWrapper
                  title={locationData.text1}
                  text={locationData.text2}
                  icon="fa-map-marker"
                />
              </div>   
            }
           
            { (serviceData.show && serviceData.status) &&
              <div className="col col-lg-4 col-md-12">
                <LabelStandart
                  title={serviceData.title}
                />
                <InfoWrapper
                  title={serviceData.text1}
                  icon="fa-list"
                />           
              </div>
            }

            { (timeData.show && timeData.status) &&
              <div className="col col-lg-4 col-md-12">
                <LabelStandart
                  title={timeData.title}
                />
                <InfoWrapper
                  title={timeData.text1}
                  text={timeData.text2}
                  icon="fa-clock-o"
                />
              </div>  
            }
          </div>
          <div className="row">
            <div className="col col-lg-4 col-md-12">
              <LabelStandart
              title="Dodatečné informace"
              />
               <InfoWrapper
                  title={locationData.place}
                  text={locationData.placeAdditionalInfo}
                />
            </div>
          </div>
        </StyledInfoPanel>
    );
  }
}


InfoPanel.propTypes = {
  locationData: PropTypes.object,
  serviceData: PropTypes.object,
  timeData: PropTypes.object,
};


export default InfoPanel;



// WEBPACK FOOTER //
// ./src/common/InfoPanel/InfoPanel.js